define('model/assignment.type.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var AssignmentTypeModel = BaseModel.extend({
    urlRoot: '/api/v1/compliance/assignmentType',
  });

  module.exports = AssignmentTypeModel;
});

